<template>
  <div class="rela">
    <transition name="fade">
      <div :id="'NECaptcha_code'+timestamp" class="NECaptcha" v-show="captcha_show"></div>
    </transition>
    <Button
      type="primary"
      long
      :disabled="!to||second>0 || btndisabled"
      @click="handleClick"
    >{{second>0?$t('btn.b68').replace('{%}',second):$t('btn.b67')}}</Button>
  </div>
</template>
<script>
// import ydinit from "@/libs/ydinit";
export default {
  props: ["type", "to", "btndisabled"],
  data() {
    return {
      NECaptchaValidate: "",
      captchaIns: null, //易盾实例
      second: 0,
      timer: null,
      captcha_show: false,
      timestamp: Date.now() //用于dom唯一标识
    };
  },
  mounted() {},
  destroyed() {
    this.timerClear();
    if (this.captchaIns) this.captchaIns.destroy();
  },
  methods: {
    handleClick() {
      if (!this.type) return;
      this.second = 60;
      this.timerStart();
      this[this.type]().then(res => {
        if (res.err) this.timerClear();
        res.throw();
      });

      // this.$axios
      //   .get("/Member/RZJAuth/UserIsLoginVerif", {
      //     params: { account: this.to }
      //   })
      //   .then(res => {
      //     console.log(res);
      //     if (res.err == 0) {
      //       this.captcha_show = false;
      //       this.second = 60;
      //       this.timerStart();
      //       this[this.type]().then(res => {
      //         if (res.err) this.timerClear();
      //         res.throw();
      //       });
      //     }
      //     if (res.err == 400) {
      //       return res.throw();
      //     }
      //     if (res == true) {
      //       if (this.captchaIns) {
      //         this.captcha_show = true;
      //       } else {
      //         this.ydinit();
      //       }
      //     }
      //   });

      // if (this.captchaIns) {
      //   this.captcha_show = true;
      // } else {
      //   this.ydinit();
      // }
    },
    timerStart() {
      this.timer = setInterval(() => {
        if (--this.second <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    timerClear() {
      this.second = 0;
      if (this.timer) clearInterval(this.timer);
    },
    // 易盾验证码初始化
    ydinit() {
      ydinit({
        element: "#NECaptcha_code" + this.timestamp,
        onVerify: (err, data) => {
          if (err) return;
          this.captcha_show = false;
          this.second = 60;
          this.NECaptchaValidate = data.validate;
          this.timerStart();
          // 验证通过 发送验证码
          this[this.type]().then(res => {
            if (res.err) this.timerClear();
            res.throw();
          });
        },
        onReady: instance => {
          this.captchaIns = instance;
          this.captcha_show = true;
        }
      });
    },

    // 手机登录
    logPhone() {
      return this.$axios.post("/Member/RZJAuth/SendLoginMobliePhoneCode", {
        NECaptchaValidate: this.NECaptchaValidate,
        mobliePhone: this.to
      });
    }
  },
  watch: {
    captcha_show(v) {
      if (v) {
        // 显示时刷新
        if (this.captchaIns) this.captchaIns.refresh();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.rela {
  position: relative;
}
.NECaptcha {
  position: absolute;
  bottom: -55px;
  left: -194px;
  z-index: 9999;
  width: 300px;
  background: #fff;
}
</style>

